import styled from 'styled-components';
import { layout, colors } from '@prisjakt/ui-base';
import { TextInput } from '@prisjakt/ui-inputs/src/inputs';
import { Link as LinkComponent } from 'react-router-dom';
import { Form } from '@prisjakt/ui-review-form';
import ShopReviewThankYouComponent from '../reviews/components/thank-you/shop-review-thank-you';

export const PurchaseReviewPage = styled.div`
  display: flex;
  justify-content: center;
  padding: ${layout.spacing.medium};
`;

export const PurchaseReviewForm = styled(Form)`
  padding: ${layout.spacing.large} ${layout.spacing.medium}
    ${layout.spacing.xxLarge} ${layout.spacing.medium};
  max-width: 600px;
  margin: auto;

  a {
    color: ${p => p.theme.text.callToAction};

    &:hover {
      color: ${p => p.theme.text.callToActionHover};
    }
  }
`;

export const EmailInput = styled(TextInput)`
  margin-top: ${layout.spacing.small};
`;

export const SotyLink = styled(LinkComponent)`
  color: ${colors.lightBlue3};
`;

export const Header = styled.h1`
  font-size: ${layout.fontSizes.h2.desktop.rem};
  margin-bottom: ${layout.spacing.small};
`;

export const ShopReviewThankYou = styled(ShopReviewThankYouComponent)`
  margin: ${layout.spacing.large} auto ${layout.spacing.xxLarge} auto;
  max-width: 600px;
  padding: 0 ${layout.spacing.medium};
`;

export const Optional = styled.span`
  color: ${p => p.theme.text.quaternary};
  font-weight: normal;
  margin-left: ${layout.spacing.xSmall};
`;

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;
